import {FC} from "react";
import IconLinkArrow from "../../../../assets/icons/link-arrow-right-up-blue.svg";
import IconZigzagAroow from "../../../../assets/icons/filters/icon-zigzag-arrow.svg";

interface IProps {
  openCharts: () => void;
}

export const MarketScienceCharts: FC<IProps> = ({openCharts}) => {
  return (
    <div
      style={{
        color: "#fff",
        backgroundColor: "#22272B",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        gap: "15px",
        width: "100%",
        cursor: "pointer",
      }}
      onClick={openCharts}
    >
      <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
        <img src={IconZigzagAroow} alt="Arrow" />
        <span>Рыночные и научные метрики</span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#56B3FF",
        }}
      >
        <span>Открыть</span>
        <img src={IconLinkArrow} alt="Arrow" />
      </div>
    </div>
  );
};
